export const inserisciModificaDisponibilitaCandidaturaLavoratore = [
  "",
  `mutation inserisciModificaDisponibilitaCandidaturaLavoratore($input: inputInserisciModificaDisponibilitaCandidaturaLavoratore!) {
    inserisciModificaDisponibilitaCandidaturaLavoratore(input: $input)
  }`,
  "inserisciModificaDisponibilitaCandidaturaLavoratore"
];
